import { useMemo } from "react";
import { createSlice } from "@reduxjs/toolkit";

import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";

import { addCreatorsSaga } from "./saga";
//
export const initialState = {
  addCreatorHistory: {
    initialLoading: true,
    loading: false,
    error: null,
    //
    total_history: 0,
    history: [],
    pagination: {}
  },
  addCreator: {
    data: null,
    loading: false,
    error: null
  },
};

export const AddCreatorSlice = createSlice({
  name: "addCreatorPage",
  initialState,
  reducers: {
    // Add Creator
    addCreator: (state, action) => {
      state.addCreator.loading = true;
      state.addCreator.error = null;
    },
    addCreatorSuccess: (state, action) => {
      state.addCreator.loading = false;
      state.addCreator.data = action.payload;
    },
    addCreatorFailure: (state, action) => {
      state.addCreator.loading = false;
      state.addCreator.error = action.payload;
    },

    // --- fetchAddCreatorHistory ---
    fetchAddCreatorHistory: (state, action) => {
      state.addCreatorHistory.loading = true;
      state.addCreatorHistory.error = null;
    },
    fetchAddCreatorHistorySuccess: (state, action) => {
      const { history, total_history, pagination } = action.payload;
      state.addCreatorHistory.loading = false;
      state.addCreatorHistory.initialLoading = false;
      state.addCreatorHistory.history = history;
      state.addCreatorHistory.total_history = total_history;
      state.addCreatorHistory.pagination = pagination;
    },
    fetchAddCreatorHistoryFailure: (state, action) => {
      state.addCreatorHistory.loading = false;
      state.addCreatorHistory.initialLoading = false;
      state.addCreatorHistory.error = action.payload;
    }
  }
});

// custom hooks
export const useAddCreatorSlice = () => {
  useInjectReducer(AddCreatorSlice.name, AddCreatorSlice.reducer);
  useInjectSaga(AddCreatorSlice.name, addCreatorsSaga);

  const actions = useMemo(() => AddCreatorSlice.actions, []);
  return { actions };
};

export const { actions: addCreatorPageActions } = AddCreatorSlice;
export default AddCreatorSlice.reducer;
